import { Stack, styled } from '@mui/material';
import { m } from 'framer-motion';

// ------------------------------------------------------------

export const StyledContainer = styled(Stack)(({ theme }) => ({
  paddingBottom: '30px',
  paddingTop: '30px',
}));

export const StyledPictureContainer = styled(m.div)(() => ({
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  justifyContent: 'center',
  gap: 30,
  height: 'auto',
}));
